module.exports = __webpack_public_path__ + "img/general-electric-tablet_ce77f62509b151ca5fb1cf3874b35438.jpg";


//////////////////
// WEBPACK FOOTER
// ./client/img/general-electric-tablet.jpg
// module id = 275
// module chunks = 0